<div class="flex h-full w-full items-center justify-center bg-proffeo-surface-page">
  <div class="flex flex-col items-center justify-center gap-5">
    <div class="flex items-center gap-4">
      <div class="flex items-center gap-2">
        <img
          src="img/logo/logo.png"
          alt="logo"
          class="w-11"
        />
        <p class="proffeo-ui-text-display">Proffeo</p>
      </div>
    </div>
    <div class="min-w-90 flex items-center justify-center rounded-md border-default bg-proffeo-surface p-8">
      <div class="flex w-full flex-col gap-2">
        <div class="flex w-full items-center gap-5 justify-between">
          <p class="proffeo-ui-text-display text-center">{{ 'sign-in-sign-in' | translate }}</p>
          <proffeo-lang-toggle class="p-2"></proffeo-lang-toggle>
        </div>
        <form
          [formRoot]="form"
          class="flex flex-col gap-4 pt-5"
        >
          <proffeo-ui-input
            [formField]="form.username"
            label="forgot-password-email-address"
            type="email"
            autocomplete="email"
          />

          <proffeo-ui-input
            [formField]="form.password"
            label="sign-in-password"
            type="password"
            autocomplete="current-password"
          />

          @if (signInError()) {
            <p class="text-sm font-light text-proffeo-danger text-center">
              {{ signInError() }}
            </p>
          }

          <div class="flex flex-col items-center justify-center gap-2">
            <div class="flex w-full items-center justify-between pt-3">
              <proffeo-ui-button
                (clicked)="signIn()"
                [disabled]="form().invalid() || form().submitting()"
                variant="accent"
                text="sign-in-sign-in"
              ></proffeo-ui-button>
              <p
                [routerLink]="['/forgot-password']"
                class="cursor-pointer text-sm hover:opacity-75"
              >
                {{ 'sign-in-forgot-password' | translate }}
              </p>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
